import React, { Component } from 'react'
import { Trans } from '@lingui/react'

import './paper-pages.styl'

import BookIcon from 'client/shared/icons/book.svg'
import SVGInline from 'react-svg-inline'

type Props = {
  paper_pages: number
}

export class PaperPages extends Component<Props> {
  render(): JSX.Element {
    const { paper_pages } = this.props

    return (
      <div className="paper-pages">
        <SVGInline className="paper-pages__icon" svg={BookIcon} />
        {paper_pages && (
          <span className="paper-pages__text">
            <Trans id="book.paper_pages" values={{ count: paper_pages }} />
          </span>
        )}
      </div>
    )
  }
}
